"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Dior = function Dior(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.767 16.383h.622c2.313 0 2.934-.214 3.748-1.296.814-1.081.91-2.634.91-3.159 0-.525-.139-1.842-.953-2.956C7.28 7.858 5.92 7.569 4.73 7.569h-.968c-.23 0-.242.102-.242.262v8.349c0 .182.065.203.247.203M0 16.58c0-.084.11-.099.211-.102 1.178-.033 1.398-.074 1.532-.214.074-.077.182-.14.182-.685v-7.51c0-.674-.82-.567-1.398-.626-.203-.02-.22-.048-.22-.107s.039-.087.145-.091h4.745c5.216 0 5.483 3.813 5.483 4.83 0 2.186-1.445 4.59-4.465 4.59H.152c-.074 0-.152-.01-.152-.086m15.638-1.98c.124 1.126.795 2.002 1.625 1.855.833-.147 1.25-.942 1.15-2.215-.103-1.295-.744-1.94-1.605-1.863-.891.081-1.296 1.097-1.17 2.223m.824-2.421c1.072-.2 2.597.036 2.944 1.714.346 1.678-.809 2.572-1.811 2.79-.98.212-2.643.06-2.943-1.744a2.35 2.35 0 0 1 1.81-2.76m-3.849-1.514a.62.62 0 1 0 0-1.24.62.62 0 0 0 0 1.24m-1.283 2.4c-.034-.066.03-.109.218-.158.21-.056.669-.196 1.033-.402.365-.206.427-.227.504-.202.078.026.07.162.07.272v3.47c0 .195.026.276.114.357.089.081.31.129.596.129.13 0 .17.015.17.07 0 .055-.04.055-.092.055h-2.517c-.077 0-.096-.033-.096-.066 0-.04.035-.067.152-.067.098 0 .554.034.657-.202.04-.09.06-.217.06-.334v-2.753c0-.21-.163-.302-.35-.257-.219.05-.474.174-.519.088m8.868-.001c-.007-.045-.007-.084.218-.155.224-.069.769-.254 1.1-.437.33-.184.386-.21.463-.159.078.051.056.177.056.265v.898c.12-.199.519-.86.834-1.056.249-.153.336-.166.49-.17.185-.003.621.111.64.572.015.36-.25.504-.42.482-.135-.02-.231-.144-.312-.27-.08-.126-.21-.202-.338-.158-.129.044-.85.512-.891 1.178-.03.49 0 2.016 0 2.016 0 .232.088.321.192.383.103.063.481.066.588.081.107.015.103.04.103.074 0 .032 0 .048-.095.048H20.29c-.08 0-.113-.016-.113-.063 0-.066.106-.055.187-.066.08-.011.51.024.633-.192.09-.141.079-.368.079-.368l-.013-2.682c0-.217-.064-.249-.123-.283-.06-.034-.16-.053-.37.019-.198.065-.334.126-.372.043Z"
  }));
};

Dior.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Dior.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Dior;
exports.default = _default;